var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShortArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 26,
    viewBox: "0 0 7 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67627 26L0.883851 22.7804L6.06835 20.2398L5.67627 26ZM6.07462 0.802193C3.00533 4.84806 0.853948 13.2251 4.16227 21.7784L3.22961 22.1391C-0.202526 13.2657 1.99678 4.52295 5.27792 0.197807L6.07462 0.802193Z",
    fill: "#999999"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortArrow);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDcgMjYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjY3NjI3IDI2TDAuODgzODUxIDIyLjc4MDRMNi4wNjgzNSAyMC4yMzk4TDUuNjc2MjcgMjZaTTYuMDc0NjIgMC44MDIxOTNDMy4wMDUzMyA0Ljg0ODA2IDAuODUzOTQ4IDEzLjIyNTEgNC4xNjIyNyAyMS43Nzg0TDMuMjI5NjEgMjIuMTM5MUMtMC4yMDI1MjYgMTMuMjY1NyAxLjk5Njc4IDQuNTIyOTUgNS4yNzc5MiAwLjE5NzgwN0w2LjA3NDYyIDAuODAyMTkzWiIgZmlsbD0iIzk5OTk5OSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };